var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.2,16.5c-0.3,0-0.5-0.1-0.7-0.3L6,12.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l2.8,2.8l6.4-6.4c0.4-0.4,1-0.4,1.4,0 s0.4,1,0,1.4l-7.1,7.1C10.7,16.4,10.5,16.5,10.2,16.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChecked);
export default __webpack_public_path__ + "static/media/icon-checked.52daf54e8b3cdc19af0d6bc0d3709a07.svg";
export { ForwardRef as ReactComponent };